export const PRODUCT_OBJ = {
    us: [
        [
            // 第一个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '7414780887113',
                variantId: '42093688946761',
                tag: 'EARLY BIRD',
            },
        ],
        [
            // 第二个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '7414780887113',
                variantId: '54347934728265',
                tag: 'EARLY BIRD',
            },
        ],
        [
            // 第三个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '7414780887113',
                variantId: '42093688848457',
                tag: 'EARLY BIRD',
            },
        ],
        [
            // 第四个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '7414796615753',
                variantId: '42093744750665',
                tag: 'EARLY BIRD',
            },
        ],
        [
            // 第五个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '7414796615753',
                variantId: '42093744816201',
                tag: 'EARLY BIRD',
            },
        ],
        [
            // 第六个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '7414796615753',
                variantId: '42093744783433',
                tag: 'EARLY BIRD',
            },
        ],
        [
            // 第七个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '7414796615753',
                variantId: '42125740539977',
                tag: 'EARLY BIRD',
            },
        ],
    ],
    ca: [
        [
            // 第一个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '15052470288755',
                variantId: '52405166506355',
                tag: 'EARLY BIRD',
            },
        ],
        [
            // 第二个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '15052470288755',
                variantId: '52476776448371',
                tag: 'EARLY BIRD',
            },
        ],
        [
            // 第三个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '15052470288755',
                variantId: '52405166440819',
                tag: 'EARLY BIRD',
            },
        ],
        [
            // 第四个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '15052472680819',
                variantId: '52427514151283',
                tag: 'EARLY BIRD',
            },
        ],
        [
            // 第五个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '15052472680819',
                variantId: '52427514249587',
                tag: 'EARLY BIRD',
            },
        ],
        [
            // 第六个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '15052472680819',
                variantId: '52427514216819',
                tag: 'EARLY BIRD',
            },
        ],
        [
            // 第七个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '15052472680819',
                variantId: '52427514282355',
                tag: 'EARLY BIRD',
            },
        ],
    ],
    uk: [],
    eu: [],
    de: [],
    fr: [],
    it: [],
    es: [],
    jp: [],
};
